export const COMPARE_METHODS = {
  SLIDER: 'SLIDER',
  SIDE_BY_SIDE: 'SIDE_BY_SIDE',
};
